/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';

export interface DownloadMonthlyDeliveryNoteReport$Params {
  organizationSiteKey: KeyType;

/**
 * Year of the report (e.g., 2025)
 */
  year: number;

/**
 * Month of the report (1-12)
 */
  month: number;
}

export function downloadMonthlyDeliveryNoteReport(http: HttpClient, rootUrl: string, params: DownloadMonthlyDeliveryNoteReport$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, downloadMonthlyDeliveryNoteReport.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('year', params.year, {});
    rb.path('month', params.month, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/zip', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

downloadMonthlyDeliveryNoteReport.PATH = '/administration/organization-sites/{organizationSiteKey}/delivery-notes/monthly-reports/{year}/{month}';
